import { Component, OnInit } from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';

@Component({
  selector: 'app-identitymanager',
  templateUrl: './identitymanager.component.html',
  styleUrls: ['./identitymanager.component.scss']
})
export class IdentitymanagerComponent implements OnInit {

  constructor(public settingComp: SettingsComponent, private appComp: AppComponent) { }

  ngOnInit() {
    this.appComp.currentPageTitle = 'Manage Identity Manager';
    this.appComp.ribbon = 'Identity Manager';
    if (!this.settingComp.item) {
      this.settingComp.setcolumnvalues();
    }

  }

}
